import { inject, Injectable } from '@angular/core';
import {
  ConfigService as AuthConfigService,
  InterceptorAuthConfig,
  InterceptorDebugConfig,
  InterceptorRetryConfig,
} from '@auth';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { InterceptorTenantConfig } from '../../../auth/models/interceptor.models';
import { TenantsService } from './tenants.service';
import { DEBUG_MODE } from '../config/debug.config';

@Injectable({ providedIn: 'root' })
export class ConfigService implements AuthConfigService {
  protected readonly DEBUG_MODE: boolean = DEBUG_MODE;
  protected readonly THRESHOLD_TIME: number = 300;
  protected readonly TENANT_ID_PROPERTY_NAME: string = 'distributorIds';

  protected readonly auth0Service = inject(AuthService);
  protected readonly tenantsService = inject(TenantsService);

  getDebugConfig(): InterceptorDebugConfig {
    return {
      debugMode: this.DEBUG_MODE,
      threshold: this.THRESHOLD_TIME,
      logTypes: {
        request: false,
        response: false,
        error: true,
        performance: false,
        finalize: false,
      },
    };
  }

  getRetryConfig(): InterceptorRetryConfig {
    return {
      maxRetries: 0,
      initialRetryDelay: 500,
      delayMultiplier: 2,
      retryableStatusCodes: [500, 502, 503, 504, 404],
      logRetryAttempts: this.DEBUG_MODE,
      logErrors: this.DEBUG_MODE,
    };
  }

  getAuthConfig(): InterceptorAuthConfig {
    return {
      debugMode: this.DEBUG_MODE,
      securedEndpoints: [API_URL],
    };
  }

  getAuthAccessToken(): Observable<string> {
    return this.auth0Service.getAccessTokenSilently();
  }

  getTenantConfig(): InterceptorTenantConfig {
    return {
      debugMode: this.DEBUG_MODE,
      securedEndpoints: [API_URL],
      tenantIdPropertyName: this.TENANT_ID_PROPERTY_NAME,
      tenantIds: this.tenantsService.retrieveSelectedTenants(),
      redirectUrl: '/welcome'
    };
  }
}
